import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UtilDadosLogado } from '../servicos/util.logado';

@Injectable()
export class InicialSerice {

  private readonly apiUrl = '/api/Inicial/PutArquivosPessoas'; // Define o endpoint base

  constructor(private http: HttpClient, private utilDadosLogado: UtilDadosLogado) { }

  private jwt(): HttpHeaders {
    const dados = JSON.parse(localStorage.getItem('AcessoAdm'));
    let headers = new HttpHeaders({
      'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001',
      'Authorization': dados && dados.TOKEN ? `Bearer ${dados.TOKEN}` : ''
    });
    return headers;
  }

  post(body: FormData): Observable<any> {
    const headers = this.jwt(); // Cria o cabeçalho com o token Bearer
    const url = `${this.utilDadosLogado.DadosAcesso().URL}${this.apiUrl}`; // Construa a URL completa

    return this.http.post<any>(url, body, { headers }); // Faz a requisição POST com o cabeçalho configurado
  }
}



// WEBPACK FOOTER //
// ./src/app/inicial/inicial.service.ts